import { inject, Injectable } from "@angular/core";
import { LgConsole } from "@logex/framework/core";
import { LocalizationJson, ReferenceTranslateCompiler } from "@logex/framework/lg-localization";

@Injectable()
export class SharedTranslateCompiler extends ReferenceTranslateCompiler {
    private readonly _console = inject(LgConsole);

    override compileTranslations(translations: LocalizationJson, lang: string) {
        return super.compileTranslations(this._omitNullTranslations(translations, lang), lang);
    }

    private _omitNullTranslations(
        translations: LocalizationJson,
        lang: string,
        path = "",
    ): LocalizationJson {
        const result: LocalizationJson = {};
        for (const [key, value] of Object.entries(translations)) {
            const translationPath = path ? `${path}.${key}` : key;
            if (value === null) {
                this._console.warn(
                    `Ignoring null translation "${translationPath}" for language "${lang}".`,
                );
                continue;
            }
            result[key] =
                typeof value === "object"
                    ? this._omitNullTranslations(value, lang, translationPath)
                    : value;
        }
        return result;
    }
}
